module.exports = __webpack_public_path__ + "img/Kontakt_Hintergrund.d8bd1e0e.jpg";